<div class="modal-header">
  <h3 class="modal-title">Add a Collaborator</h3>
</div>
<div class="modal-body clearfix">
  <div class="container-fluid">
    <div class="col-lg-12">
      <div class="input">
        <input
          #currentFilter
          (keyup)="onKey(currentFilter.value)"
          placeholder="type name here..." />
      </div>
      <div class="collaborators-list">
        <ng-container *ngFor="let participant of filteredList">
          <p
            *ngIf="
              participant && participant.user && participant.user.registered
            "
            (click)="onSelect(participant)"
            [ngClass]="{ selected: participant === selectedParticipant }">
            <profile-picture [user]="participant.user"></profile-picture>
            <name-tag [user]="participant.user"></name-tag>
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="closeAndAddCollaborator()">
    Add as collaborator
  </button>
</div>
